import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import config from '../config';

const MaintenancePage = () => {
    const [checking, setChecking] = useState(false);

    useEffect(() => {
        // Check if maintenance mode is still active every 30 seconds
        const interval = setInterval(async () => {
            setChecking(true);
            try {
                const response = await fetch(`${config.api.API_URL}/health`);
                if (response.ok) {
                    // Maintenance mode is off, reload the page
                    window.location.reload();
                }
            } catch (error) {
                // Still in maintenance mode
            } finally {
                setChecking(false);
            }
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Container>
                <div style={{
                    background: 'white',
                    borderRadius: '20px',
                    padding: '60px 40px',
                    maxWidth: '600px',
                    margin: '0 auto',
                    textAlign: 'center',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                    animation: 'slideIn 0.5s ease-out'
                }}>
                    <div style={{
                        width: '120px',
                        height: '120px',
                        margin: '0 auto 30px',
                        background: '#f0f0f0',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '60px'
                    }}>
                        🔧
                    </div>
                    
                    <h1 style={{ fontSize: '32px', marginBottom: '20px', color: '#2d3748' }}>
                        Wartungsarbeiten
                    </h1>
                    
                    <p style={{ fontSize: '18px', lineHeight: '1.6', color: '#4a5568', marginBottom: '30px' }}>
                        Wir aktualisieren gerade unsere Systeme, um Ihnen eine noch bessere Erfahrung zu bieten.
                        Die Anwendung ist in wenigen Minuten wieder verfügbar.
                    </p>
                    
                    <div style={{
                        width: '100%',
                        height: '6px',
                        background: '#e2e8f0',
                        borderRadius: '3px',
                        overflow: 'hidden',
                        margin: '30px 0'
                    }}>
                        <div style={{
                            height: '100%',
                            background: 'linear-gradient(90deg, #667eea, #764ba2)',
                            borderRadius: '3px',
                            animation: 'progress 2s ease-in-out infinite'
                        }} />
                    </div>
                    
                    <p style={{ fontSize: '14px', color: '#718096', marginTop: '20px' }}>
                        {checking ? (
                            <>Prüfe Status... <span className="spinner-border spinner-border-sm ms-2" /></>
                        ) : (
                            'Bitte haben Sie einen Moment Geduld. Bei längeren Wartungsarbeiten informieren wir Sie per E-Mail.'
                        )}
                    </p>
                </div>
            </Container>
            
            <style>{`
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes progress {
                    0% { width: 0%; }
                    50% { width: 70%; }
                    100% { width: 100%; }
                }
            `}</style>
        </div>
    );
};

export default MaintenancePage;